const firstLetter = (word?: string) => (word ? `${word[0]}.` : '');

export default firstLetter;
